import axios from 'axios';
import { Log } from '../types/Log';
import { formatToLocale, stringToUTC } from '../utils/dateUtils';
import { KAPTAIN_URL } from './config';
import { WorkflowJob } from '../types/WorkflowJob';

export const getWorkflowList = async (): Promise<WorkflowJob[]> => {
  const response = await axios.get<WorkflowJob[]>(
    `${KAPTAIN_URL}/api/workflow/tasks`
  );
  const raw = response.data;
  return raw.map((item) => {
    return {
      ...item,
      lastFinishedAt:
        item.lastFinishedAt &&
        formatToLocale(stringToUTC(item.lastFinishedAt), 'yyyy-MM-dd HH:mm:ss'),
    };
  });
};

export const getConfiguration = async (): Promise<Record<string, any>> => {
  const response = await axios.get<any>(`${KAPTAIN_URL}/api/workflow/config`);
  return response.data;
};
export const patchConfiguration = async (
  config: Record<string, any>
): Promise<void> => {
  const response = await axios.put<any>(
    `${KAPTAIN_URL}/api/workflow/config`,
    config
  );
};
